<div class="header-top">
  <div class="details">
    <img class="scale-img" src="/assets/images/definitions/back.svg" (click)="back()" />
    <que-logo-display [isHeader]="true"></que-logo-display>
    <div>
      <div class="warp-name">
        <p class="name" *ngIf="name$ | async as name; else placeholder">
          {{ name }}
        </p>
        <que-questionnaire-status class="status" [status]="status$()"></que-questionnaire-status>
      </div>
      <div class="folder" *ngIf="category$ | async as c">
        <img class="scale-img" src="/assets/images/definitions/folder.svg" />
        <p translate [translateParams]="{ category: c }">grid.categoryName</p>
      </div>
    </div>
  </div>
  <div class="warp-left">
    <div class="save-recently" *ngIf="notLoadingSave$(); else loadingSave">
      <img class="scale-img" (click)="save()" src="/assets/images/name-header/save-recently.svg" />
      <p *ngIf="recentlySave$ | async" translate>saveRecently</p>
      {{ recentlySave$ | async | date : "HH:mm" }}
    </div>
    <!-- <div *ngIf="isApiExposureEnabled" class="warp-active-toggle">
      <p translate>definitions.apiExposureEnabled</p>
      <que-toggle [toggleState]="apiExposureEnabled.value ?? false"
        (toggleEvent)="changeApiExposureEnabled($event)"></que-toggle>
    </div>
    <div *ngIf="isUnauthorized" class="warp-active-toggle">
      <p translate>definitions.isUnauthorized</p>
      <que-toggle [toggleState]="isUnauthorized.value ?? false"
        (toggleEvent)="changeIsUnauthorized($event)"></que-toggle>
    </div>
    <div *ngIf="isApprovalRequiredEnabled" class="warp-active-toggle">
      <p translate>definitions.isApprovalRequired</p>
      <que-toggle [toggleState]="isApprovalRequired.value ?? false"
        (toggleEvent)="changeIsApprovalRequired($event)"></que-toggle>
    </div> -->

    <div class="left-buttons" (click)="openSettings()">
      <img src="/assets/images/settings.svg" />
    </div>

    <div class="left-buttons pointer" (click)="goToPreview()">
      <img src="/assets/images/preview-eye.svg" />
    </div>

    <que-save></que-save>
  </div>
</div>
<ng-template #placeholder>
  <p *ngIf="notLoading$()" class="name" translate>header.questinnaireName</p>
</ng-template>
<ng-template #loadingSave>
  <div class="load-save">
    <p translate>saveLoading</p>
    <img class="load-img" src="/assets/images/loading/save-loading.svg" />
  </div>
</ng-template>